const useFilters = (activeFilters) => {
  const filterDestination = (raw) => {
    if (activeFilters.destination.slug === 'All') {
      return raw;
    } else {
      return raw.filter((item) => {
        if (item.destinations && item.destinations.length > 0) {
          const {
            destination: { id },
          } = activeFilters;

          const itemIds = item.destinations.map((dest) => dest.id);

          return itemIds.includes(id);
        }

        return false;
      });
    }
  };

  const filterTravelType = (raw) => {
    // Potentially we can make this more streamlined based on the matchFunction in findTravelTypeBySlug
    switch (activeFilters.travelType.slug) {
      case 'All':
        return raw;
      case 'group':
        return raw.filter((item) => {
          if (item.travel_type) {
            return (
              activeFilters.travelType.subtypeSlug ===
              item.travel_type.subtypeSlug
            );
          }

          return false;
        });
      case 'private':
        return raw.filter((item) => {
          if (item.travel_type) {
            return activeFilters.travelType.slug === item.travel_type.slug;
          }

          return false;
        });
    }
  };

  const filterFinderDestination = (raw) => {
    if (activeFilters.destination.length < 1) {
      return raw;
    } else {
      // flatten active filter destinations
      let flattenedDestinationsFilter = [];
      activeFilters.destination.forEach((destination) => {
        if (destination.children) {
          flattenedDestinationsFilter = [
            ...flattenedDestinationsFilter,
            destination.id,
            ...destination.children,
          ];
        } else {
          flattenedDestinationsFilter = [
            ...flattenedDestinationsFilter,
            destination.id,
          ];
        }
      });

      return raw.filter((holiday) => {
        if (holiday.destinations && holiday.destinations.length > 0) {
          const holidayDestinationIds = holiday.destinations.map(
            ({ id }) => id
          );

          return holidayDestinationIds.some((id) =>
            new Set(flattenedDestinationsFilter).has(id)
          );
        }

        return false;
      });
    }
  };

  const filterFinderCollection = (raw) => {
    if (activeFilters.collection.length < 1) {
      return raw;
    } else {
      // flatten active filter collections
      let flattenedCollectionFilter = [];
      activeFilters.collection.forEach((collection) => {
        flattenedCollectionFilter = [
          ...flattenedCollectionFilter,
          collection.id,
        ];
      });

      return raw.filter((holiday) => {
        if (holiday.collections && holiday.collections.length > 0) {
          const holidayCollectionIds = holiday.collections.map(({ id }) => id);

          return holidayCollectionIds.some((id) =>
            new Set(flattenedCollectionFilter).has(id)
          );
        }

        return false;
      });
    }
  };

  const filterFinderStyle = (raw) => {
    if (activeFilters.holidayStyle.length < 1) {
      return raw;
    } else {
      // flatten active filter collections
      let flattenedHolidayStyleFilter = [];
      activeFilters.holidayStyle.forEach((holidayStyle) => {
        flattenedHolidayStyleFilter = [
          ...flattenedHolidayStyleFilter,
          holidayStyle.id,
        ];
      });

      return raw.filter((holiday) => {
        if (holiday.holidayStyles && holiday.holidayStyles.length > 0) {
          const holidayStyleIds = holiday.holidayStyles.map(({ id }) => id);

          return holidayStyleIds.some((id) =>
            new Set(flattenedHolidayStyleFilter).has(id)
          );
        }

        return false;
      });
    }
  };

  const filterReviewTag = (raw) => {
    if (activeFilters) {
      const returner = raw.filter(({ tags }, index) => {
        if (tags) {
          const filteredTags = tags.filter(
            (tag) => tag.slug === activeFilters.slug
          );

          return filteredTags.length > 0;
        }

        return false;
      });

      return returner;
    } else return raw;
  };

  return {
    filterDestination,
    filterFinderDestination,
    filterTravelType,
    filterFinderCollection,
    filterFinderStyle,
    filterReviewTag,
  };
};

export default useFilters;
